// @flow
import { styled } from 'mz-ui-kit';

export const Container = styled('div', {
  display: 'flex',
  width: '100%',
  height: '100%',
  justifyContent: 'space-between',
  alignItems: 'start',
  textAlign: 'center'
});

export const Item = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  flexBasis: '25%',
  justifyContent: 'start',
  alignItems: 'center',
  paddingLeft: '25px',
  paddingRight: '25px'
});

export const Icon = styled('div', ({ $src }) => ({
  width: '40px',
  minHeight: '40px',
  backgroundImage: `url(${$src})`,
  backgroundSize: 'cover',
  marginBottom: '10px'
}));

export const Title = styled('span', {
  color: '#999',
  fontSize: '14px',
  textAlign: 'center',
  width: '100%'
});
